module.exports = __webpack_public_path__ + "static/shapeLeft2-f1274612c5e7f04c612bc8f68a1c02ba.png";